import { render, staticRenderFns } from "./UploadCardDetail.vue?vue&type=template&id=49f6b6aa&scoped=true&"
import script from "./UploadCardDetail.vue?vue&type=script&lang=js&"
export * from "./UploadCardDetail.vue?vue&type=script&lang=js&"
import style0 from "./UploadCardDetail.vue?vue&type=style&index=0&id=49f6b6aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f6b6aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49f6b6aa')) {
      api.createRecord('49f6b6aa', component.options)
    } else {
      api.reload('49f6b6aa', component.options)
    }
    module.hot.accept("./UploadCardDetail.vue?vue&type=template&id=49f6b6aa&scoped=true&", function () {
      api.rerender('49f6b6aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/mix/UploadCardDetail.vue"
export default component.exports